import moment from 'moment';
import { makeRequest } from 'services/utils';
import { DateFormats } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';

export const getDashboardStats = ({ queryParams }) =>
  makeRequest({
    endpointOptions: {
      path: Endpoints.DashboardBulkEmail,
      queryParams: {
        ...queryParams,
        startDate: moment(queryParams.startDate).format(DateFormats.QueryFormat),
        endDate: moment(queryParams.endDate).format(DateFormats.QueryFormat)
      }
    },
    apiVersion: 2,
    method: 'get'
  });
